export default __webpack_public_path__ + "static/media/Icon-right-arrow.6548d37e.svg";